// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1166":"f02b5935","2612":"a6506f96","4247":"e70b9d3a","5773":"caf4b8cf","9289":"9a6314db"}[chunkId] + ".chunk.css";
};